import { UntypedFormGroup, UntypedFormControl,ValidationErrors, AbstractControl, ValidatorFn } from '@angular/forms';

export function emailValidator(control: UntypedFormControl): { [key: string]: any } | null {
  const emailRegexp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;  // improved regexp

  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }

  return null;  // important: always return null if valid
}


export function matchingPasswords(passwordKey: string, passwordConfirmationKey: string) {

  return (group: UntypedFormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true })
    }
  }
}

export function noWhitespaceValidator(control: UntypedFormControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'required': true };
}
export function dateComparision(fromDate: any, toDate: any) {
  return (group: UntypedFormGroup) => {
    let startDate = group.controls[fromDate];
    let endDate = group.controls[toDate];
    if (endDate.value < startDate.value) {
      return endDate.setErrors({ mismatchedDate: true })
    }
  }


}
export function validateAllFormFields(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach(field => {
    const control:any = formGroup.get(field);
    control.markAsTouched({ onlySelf: true });
  });
}

export function conditionalValidator(condition: (() => boolean), validator: ValidatorFn): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any }| null  => {
    if (!condition()) {
      return null;
    }
    return validator(control);
  }
}

export function constructRule(inputJson: any) {
  inputJson = inputJson.statement;
  inputJson = inputJson.groups[0];
  return constructRuleStmt(inputJson, '', false, '');
}

export function constructRuleStmt(inputJson: any, ruleStmt: string, isGroupNestedGroup: boolean, conjunctor: string) {
  if (conjunctor === 'AND') {
    conjunctor = '&&';
  }
  if (conjunctor === 'OR') {
    conjunctor = '||';
  }
  if (isGroupNestedGroup) {
    ruleStmt = ruleStmt + ' ' + conjunctor + ' ';
    ruleStmt = ruleStmt + ' ( ';
  }

  if (inputJson.hasOwnProperty('conditions')) {
    const jsonArray = (inputJson.conditions as Array<any>);
    for (let i = 0; i < jsonArray.length; i++) {
      const jsonObject = jsonArray[i] as object;
      // @ts-ignore
      ruleStmt = ruleStmt + '$.' + jsonObject.filedName + ' ' + jsonObject.operators + ' "' + jsonObject.fieldValue + '"';
      if (i !== jsonArray.length - 1) {
        let conjunctorTemp = inputJson.conjunctor;
        if (conjunctorTemp === 'AND') {
          conjunctorTemp = '&&';
        }
        if (conjunctorTemp === 'OR') {
          conjunctorTemp = '||';
        }
        ruleStmt = ruleStmt + ' ' + conjunctorTemp + ' ';
      }
    }
  }
  if (inputJson.hasOwnProperty('groups')) {
    const jsonArray = (inputJson.groups as Array<any>);
    for (let i = 0; i < jsonArray.length; i++) {
      const jsonObject:any = jsonArray[i] as object;
      if(jsonObject['conditions'].length>0){
      
        ruleStmt = constructRuleStmt(jsonObject, ruleStmt, true, inputJson.conjunctor);
        ruleStmt = ruleStmt + ' ) ';
      }
    
    }
  }
  return ruleStmt;
}

export const trimValidator:ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.value.startsWith(' ')) {
    return {
      'trimError': { value: 'control has leading whitespace' }
    };
  }
  if (control.value.endsWith(' ')) {
    return {
      'trimError': { value: 'control has trailing whitespace' }
    };
  }
  return null;
};

export function download(data: any) {


  //var filename=headers['filename'];
  if (data.headers.get('filename') != null) {
    var filename = data.headers.get('filename');
  }
  else {
    filename = 'local_.xls';
  }
  var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
  }
}

export function downloadImage(data: any,fileName:any) {


  //var filename=headers['filename'];
 
   var filename = fileName;
   var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
  }
}



export function downloads(data: any,fileName:any) {
  var filename = fileName;
  var contentType = data.headers.get('content-type');
  var linkElement = document.createElement('a');
  try {
    var blob = new Blob([data.body], { type: contentType });
    var url = window.URL.createObjectURL(blob);

    linkElement.setAttribute('href', url);
    linkElement.setAttribute("download", filename);

    var clickEvent = new MouseEvent("click", {
      "view": window,
      "bubbles": true,
      "cancelable": false
    });
    linkElement.dispatchEvent(clickEvent);
  }
  catch (ex) {
  }
}


export function view(data: any, fileName: any): string | null {
  const contentType = data.headers.get('content-type');
  try {
    const blob = new Blob([data.body], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    return url;
  } catch (ex) {
    console.error('Error creating blob URL:', ex);
    return null;  // Return null on error
  }
}


export function getPageSize(size: any): number[] | null {
  if (size > 10) {
    return [5, 10, 15];
  } else if (size > 5) {
    return [5, 10];
  } else {
    return null;
  }
}



export function resource(size:any) {



  // let object = {
  //   read: privilegeMapping[0].hasReadPermission,
  //   write:
  // }



}


export class ResourceAccess {
  static MigrateDatamappingService(MigrateDatamappingService: any) {
    throw new Error('Method not implemented.');
  }
  public static CREDIT_MEMO = 'creditMemo';
  public static ORDER = 'order';
  public static INVOICE = 'invoice';
  public static SHIPMENT = 'shipment';
  public static TAX = 'tax';
  public static PROFILE = 'profile';
  public static ADMIN_CUSTOMER = 'adminCustomer';
  public static PRODUCT = 'product';
  public static CATEGORY = 'category';
  public static ATTRIBUTE = 'attribute';
  public static ATTRIBUTE_SET = 'attributeSet';
  public static REVIEW = 'adminReview';
  public static CATALOG_SEARCH_QUERY = 'catalogSearchQuery';
  public static CUSTOMER = 'adminCustomer';
  public static ACCESS = 'userRole';
  public static ACCESS_SET = 'accessSet';
  public static CATALOG_RULE = 'catalogRule';
  public static NEWS_LETTER_SUBSCRIBER = 'adminNewsletterSubscriber';
  public static CMS = 'cmsPage';
  public static ABANDONED_CART = 'abandonedCart';
  public static CART_PRODUCT = 'cartProduct';
  public static CURRENCY = 'adminCurrency';
  public static INDEX = 'Index';
  public static SHIPPING_TABLE_RATE = 'adminShippingTablerate';
  public static ORDER_STATUS = 'orderStatus';
  public static CONFIG = 'adminConfig';
  public static DELIVERY_COUNTRY = 'deliveryCountry';
  public static PRODUCT_CONFIG = 'productCustomization';
  public static COUPON = 'adminCoupon';
  public static PINCODE = 'pincode';
  public static BANNER = 'coreConfigSlider';
  public static TRANSLATE = 'coreTranslate';
  public static CONSULTATION = 'consultation';
  public static LAYOUT = 'layout';
  public static BANNER_ADVANCED = 'coreConfigSliderAdvanced';
  public static UNITS = 'units';
  public static LANGUAGE = 'language';
  public static PAYMENT_MODE = 'paymentMode';
  public static SUPPLIER = 'supplier';
  public static WAREHOUSE = 'warehouse';
  public static CONTACT = 'contact';
  public static FOOTERICON = 'footerIcon';
  public static MEDICAL_DELIVERY_OPTION = 'medicalDelivery';
  public static PURCHASE = 'purchase';
  public static PRODUCT_QTY_REPORT = 'productQtyReport';
  public static MEDICAL_DATA_MAPPING= 'medicalDataMapping';
  public static SHOPDATA = 'shopdata';
  public static SUPPLIER_DISCOUNT = 'supplierDiscount';
  public static SUPPLIER_COMMISSION = 'supplierCommission';
  
  public static REFERRAL = 'referral';
  public static REFERRALPRODUCT = 'referralProduct';
  public static REFERALPRODUCTITEM = 'referalProductItem';
  public static REFERALORDERITEMS = 'referalOrderItems';
  public static REFERALCUSTOMER = 'referalCustomer';


}

export class Audit {
  public static AUDIT_PRODUCT = "com.calsoft.ecom.model.productindex.ProductIDX2";
  public static AUDIT_USER = "com.calsoft.ecom.model.customerindex.CustomerIDX";
  public static AUDIT_CATEGORY = "com.calsoft.ecom.model.categoryindex.CategoryIDX";
}




export class comparisonValidator {
  /**
   * Must match validator
   *
   * @param controlPath A dot-delimited string values that define the path to the control.
   * @param matchingControlPath A dot-delimited string values that define the path to the matching control.
   */
  static mustMatch(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      // The control must be a form group
      const group = formGroup as UntypedFormGroup;

      const control = group.get(controlPath);
      const matchingControl = group.get(matchingControlPath);

      if (!control || !matchingControl) {
        return null;
      }

      // Delete the mustMatch error to reset the error on the matching control
      if (matchingControl.errors && matchingControl.errors['mustMatch']) {
        const errors = { ...matchingControl.errors };
        delete errors['mustMatch'];
        matchingControl.setErrors(Object.keys(errors).length ? errors : null);
      }

      // Don't validate empty values on the matching control
      // Don't validate if values are matching
      if (this.isEmptyInputValue(matchingControl.value) || control.value === matchingControl.value) {
        return null;
      }

      // Set the validation error on the matching control
      matchingControl.setErrors({
        ...matchingControl.errors,
        mustMatch: true
      });

      return null;
    };
  }

  /**
   * Check for empty (optional fields) values
   *
   * @param value
   */
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }
}



export class nullCheckValidator {
  /**
   * Must match validator
   *
   * @param controlPath A dot-delimited string values that define the path to the control.
   * @param matchingControlPath A dot-delimited string values that define the path to the matching control.
   */
  static mustMatch(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const group = formGroup as UntypedFormGroup;

      const control = group.get(controlPath);
      const matchingControl = group.get(matchingControlPath);

      if (!control || !matchingControl) {
        return null;
      }

      // Clear previous "empty" error if present
      if (matchingControl.errors && matchingControl.errors['empty']) {
        const errors = { ...matchingControl.errors };
        delete errors['empty'];
        matchingControl.setErrors(Object.keys(errors).length ? errors : null);
      }

      if (control.errors && control.errors['empty']) {
        const errors = { ...control.errors };
        delete errors['empty'];
        control.setErrors(Object.keys(errors).length ? errors : null);
      }

      // Check if matchingControl is empty
      if (this.isEmptyInputValue(matchingControl.value)) {
        matchingControl.setErrors({
          ...matchingControl.errors,
          empty: true
        });
      }

      // Check if control is empty
      if (this.isEmptyInputValue(control.value)) {
        control.setErrors({
          ...control.errors,
          empty: true
        });
      }

      return null;
    };
  }

  /**
   * Check for empty (optional fields) values
   *
   * @param value
   */
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }
}




export class lessThanValidator {
  /**
  * Must match validator for dates
  *
  * @param controlPath A dot-delimited string values that define the path to the control.
  * @param matchingControlPath A dot-delimited string values that define the path to the matching control.
  */
  static mustMatchDate(controlPath: string, matchingControlPath: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const formGroup = control as UntypedFormGroup;

      // Get the control and matching control
      const sourceControl = formGroup.get(controlPath);
      const targetControl = formGroup.get(matchingControlPath);

      // Return if either control doesn't exist
      if (!sourceControl || !targetControl) {
        return null;
      }

      // Clean previous error if necessary
      if (targetControl.errors?.['mismatchedDate']) {
        delete targetControl.errors?.['mismatchedDate'];

        // If no other errors remain, clear the errors object
        if (Object.keys(targetControl.errors).length === 0) {
          targetControl.setErrors(null);
        } else {
          targetControl.setErrors({ ...targetControl.errors });
        }
      }

      // If valid (source <= target), no error
      if (sourceControl.value <= targetControl.value) {
        return null;
      }

      // Set the validation error on the matching control
      targetControl.setErrors({
        ...(targetControl.errors || {}),
        mismatchedDate: true
      });

      // The group validator returns null (always, because it sets the error on child control)
      return null;
    };
  }

  /**
  * Check for empty (optional fields) values
  */
  static isEmptyInputValue(value: any): boolean {
    return value == null || value.length === 0;
  }
}
